import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { convertNotesDateToPST } from '../../../../helpers/audit-trail';

const useStyles = makeStyles({
  counterDiv: {
    border: 'solid 1px transparent',
    borderRadius: '17px',
    height: '29px',
    display: 'inline-flex',
  },
  normalGradient: {
    background: 'linear-gradient(to right, #0783FE, #9747FF)',
  },
  negativeGradient: {
    background: 'linear-gradient(to right, #FD4962, #C1272D)',
  },
  typography: {
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '16.94px',
    color: '#fff',
  },
  negativeText: {
    color: '#FD4962',
  },
  circle: {
    width: '24px',
    height: '24px',
    backgroundColor: '#0783FE',
    borderRadius: '50%',
  },
});

const CountdownTimer = ({ targetDateTime }) => {
  const classes = useStyles();

  const calculateTimeLeft = () => {
    const now = new Date();
    const nowPST = new Date(now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
    const target = new Date(convertNotesDateToPST(targetDateTime));
    const difference = target - nowPST;
    const totalSeconds = target.getHours() * 60 * 60 + target.getMinutes() * 60 + target.getSeconds();
    const totalCurrentSeconds = nowPST.getHours() * 60 * 60 + nowPST.getMinutes() * 60 + nowPST.getSeconds();
    const initialPercentage = 100 - (100 / totalSeconds) * totalCurrentSeconds;
    const percentageBySec = 100 / totalSeconds;
    let timeLeft = {};

    if (difference >= 0) {
      timeLeft = {
        sign: '',
        hours: Math.floor(difference / (1000 * 60 * 60)),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        initialPercentageValue: initialPercentage,
        percentageBySecValue: percentageBySec,
      };
    } else {
      const positiveDifference = Math.abs(difference);
      timeLeft = {
        sign: '- ',
        hours: Math.floor(positiveDifference / (1000 * 60 * 60)),
        minutes: Math.floor((positiveDifference / (1000 * 60)) % 60),
        initialPercentageValue: initialPercentage,
        percentageBySecValue: percentageBySec,
      };
    }

    return timeLeft;
  };
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [conterPercentage, setCounterPercentage] = useState(timeLeft?.initialPercentageValue);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 60000);

    return () => {
      clearInterval(timer);
    };
  }, [targetDateTime]);

  useEffect(() => {
    const secTimer = setInterval(() => {
      if (timeLeft.sign !== '- ') {
        const newPercentage = conterPercentage - timeLeft?.percentageBySecValue;
        if (newPercentage) {
          setCounterPercentage(newPercentage);
        }
      }
    }, 1000);
    return () => {
      clearInterval(secTimer);
    };
  }, [timeLeft?.initialPercentageValue, conterPercentage]);
  const formatTime = () => {
    let timerFormatted = '';
    const isNegative = timeLeft.sign === '- ';
    if (timeLeft.hours > 0 || !isNegative) {
      if (timeLeft.hours === 0) {
        timerFormatted = `${String(timeLeft.minutes).padStart(2, '0')} mins`;
      } else {
        timerFormatted = `${timeLeft.sign}${String(timeLeft.hours).padStart(2, '0')} hour ${String(
          timeLeft.minutes
        ).padStart(2, '0')} mins`;
      }
    } else {
      timerFormatted = `${timeLeft.sign}${String(timeLeft.hours).padStart(2, '0')}:${String(timeLeft.minutes).padStart(
        2,
        '0'
      )} mins`;
    }

    return (
      <div className={`${classes.counterDiv} ${isNegative ? classes.negativeGradient : classes.normalGradient}`}>
        <div
          style={{
            background: '#3E414B',
            borderRadius: '17px',
            display: 'inline-flex',
            alignItems: 'center',
            padding: '3px 5px',
          }}
        >
          {!isNegative && (
            <div
              className={classes.circle}
              style={{
                background: 'linear-gradient(to right, #0783FE, #9747FF)',
                mask: `conic-gradient(#000 0% ${conterPercentage}%, transparent ${conterPercentage}% 100%)`,
              }}
            />
          )}
          <Typography
            className={`${classes.typography} ${isNegative ? classes.negativeText : ''}`}
            style={{ paddingLeft: '8px' }}
          >
            {timerFormatted}
          </Typography>
        </div>
      </div>
    );
  };

  return <>{formatTime()}</>;
};

CountdownTimer.defaultProps = {
  targetDateTime: undefined,
};

CountdownTimer.propTypes = {
  targetDateTime: PropTypes.string,
};

export default CountdownTimer;
